export const ProfileLocationsAPI = () => {
	const { bugsnagClient } = window;
	const { api, apiVersionHeader } = window.Bark;

	const getLocations = (success, failure) => {
		// Mock data
		let mockManyLocations = {
			data: [
				{
					type: 'seller_locations',
					id: '123456-7890',
					attributes: {
						priority: 0,
						label: 'Head Office',
						lat: 55.95325169976716,
						lng: -3.1897317128280553,
						google_places_id: '1235678',
						location_string: '2 Princes St, Edinburgh, EH1 3YY',
						display_location_as: 'Edinburgh EH1',
						location_is_private: true,
					},
				},
				{
					type: 'seller_locations',
					id: '987654-3210',
					attributes: {
						priority: 1,
						label: 'Leeds Office',
						lat: 53.79594179914209,
						lng: 1.5402532979301953,
						google_places_id: '8765432',
						location_string: 'Call Lane, Leeds, LS1 7BR',
						display_location_as: 'Leeds LS1',
						location_is_private: true,
					},
				},
			],
		};

		let mockNoPrimaryLocation = {
			data: [
				{
					type: 'seller_locations',
					id: '987654-3210',
					attributes: {
						priority: 1,
						label: 'Leeds Office',
						lat: 53.79594179914209,
						lng: 1.5402532979301953,
						google_places_id: '8765432',
						location_string: 'Call Lane, Leeds, LS1 7BR',
						display_location_as: 'Leeds LS1',
						location_is_private: true,
					},
				},
			],
		};

		let mockNoLocation = {};

		api(
			`/seller/profilelocations/`,
			null,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to get locations`);
				}
			},
			'GET',
			apiVersionHeader('v2'),
		);
	};

	const getLocation = (data, success, failure) => {
		let { locationId } = data;
		let mockSuccess = {
			data: [
				{
					type: 'seller_locations',
					id: '123456-7890',
					attributes: {
						priority: 0,
						label: 'Head Office',
						lat: 55.95325169976716,
						lng: -3.1897317128280553,
						google_places_id: '1235678',
						location_string: '2 Princes St, Edinburgh, EH1 3YY',
						display_location_as: 'Edinburgh EH1',
						location_is_private: true,
					},
				},
			],
		};
		api(
			`/seller/profilelocations/${locationId}`,
			null,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to get individual location: ${locationId}`);
				}
			},
			'GET',
			apiVersionHeader('v2'),
		);
	};

	const saveLocations = (data, success, failure) => {
		let { locations } = data;
		let mockLocationData = {
			locations: [
				{
					priority: 0,
					label: 'Head Office',
					lat: 55.95325169976716,
					lng: -3.1897317128280553,
					google_places_id: '1235678',
					location_string: 'Old Printworks, 2 Princes St, Edinburgh, EH1 3YY',
					location_is_private: true,
				},
			],
		};
		api(
			`/seller/profilelocations/`,
			data,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to save locations`);
				}
			},
			'POST',
			apiVersionHeader('v2'),
		);
	};

	const saveLocation = (locationId, data, success, failure) => {
		api(
			`/seller/profilelocations/${locationId}`,
			data,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to save location: ${locationId}`);
				}
			},
			'PUT',
			apiVersionHeader('v3'), // DANGER DANGER WILL ROBINSON -- THIS IS VERSION 3 OF THE API. ALL OTHER CALLS ARE V2
		);
	};

	const getLocationSettings = (success, failure) => {
		let mockUnavailable = {
			data: {
				location_is_unavailable: true,
				location_is_unavailable_reason: 'multiple',
			},
		};

		let mockAvailable = {
			success: true,
			data: {
				location_is_unavailable: false,
				location_is_unavailable_reason: null,
			},
		};

		let mockNoData = {
			success: true,
		};

		let mockFailure = {
			success: false,
		};

		api(
			`/seller/settings/location`,
			null,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to get location settings`);
				}
			},
			'GET',
			apiVersionHeader('v2'),
		);
	};

	const saveLocationSettings = (data, success, failure) => {
		let mockUnavailable = {
			location_is_unavailable: true,
			location_unavailable_reason: 'multiple',
		};
		let mockAvailable = {
			location_is_unavailable: false,
			location_unavailable_reason: null,
		};

		api(
			`/seller/settings/location`,
			data,
			(res) => {
				success(res);
			},
			(error) => {
				if (failure) {
					failure(error);
				} else {
					defaultFailCallback(error, `Failed to get location settings`);
				}
			},
			'POST',
			apiVersionHeader('v2'),
		);
	};

	const softDeleteLocation = (data, success, failure) => {
		let { locationId } = data;
		//TODO: In future, when we support soft delete.
	};

	const defaultFailCallback = (error, message) => {
		bugsnagClient.notify(new Error(message), { metaData: error });
	};

	const mockApi = (
		successResponse,
		failResponse,
		path,
		data,
		success,
		failure,
		method,
		headers,
		preventRefresh,
		contentType,
		processData,
	) => {
		setTimeout(() => {
			success(successResponse);
		}, 500);
	};

	return {
		getLocations,
		getLocation,
		saveLocations,
		saveLocation,
		getLocationSettings,
		saveLocationSettings,
	};
};
